var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("Header", _vm._b({}, "Header", _vm.$route.meta, false)),
        _c("b-loading", {
          attrs: { active: _vm.loading, "is-full-page": "" },
          on: {
            "update:active": function ($event) {
              _vm.loading = $event
            },
          },
        }),
        _c("i", [
          _vm._v("Please try to download your files before generating files"),
        ]),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-one-third" },
            [
              _c(
                "b-button",
                {
                  staticClass: "button is-link",
                  attrs: { "icon-left": "database" },
                  on: { click: _vm.downloadSqliteFile },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("pages.admin_panel.download_sqlite_file")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "column is-one-third" },
            [
              _c(
                "b-button",
                {
                  staticClass: "button is-link",
                  attrs: { "icon-left": "file-csv" },
                  on: { click: _vm.downloadInitDbCSV },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("pages.admin_panel.download_initdb_file")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "column is-one-third" },
            [
              _c(
                "b-button",
                {
                  staticClass: "button is-dark",
                  attrs: { "icon-left": "compact-disc" },
                  on: { click: _vm.generateDbFiles },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("pages.admin_panel.generate_db_files")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-one-third" },
            [
              _c(
                "b-button",
                {
                  staticClass: "button is-link",
                  attrs: { "icon-left": "database" },
                  on: { click: _vm.runClosureMail },
                },
                [_vm._v(" Run Closure Mail Job ")]
              ),
              _c(
                "b-button",
                {
                  staticClass: "button is-link",
                  attrs: { "icon-left": "database" },
                  on: { click: _vm.runInventoryDemandMail },
                },
                [_vm._v(" Run Inventory Demand Mail Job ")]
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }